import { http } from "./config";

export default {
  listar: (loja) => {
    var query = loja!=""?`?cd_loja=${loja}`:""
    console.log("cardapio.php"+query)
    return http.get("cardapio.php"+query);
  },
  listarQtd:(cd) => {
    return http.get('cardapio_qtd.php?cd='+cd)
  },  
  alteraQtd:(estoque) => {
    
    return http.put('cardapio_qtd_alterar.php',(estoque))
  }  
};